import type { ReactNode } from "react";

export function Card({ title, children, right }: {
  title?: string;
  right?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className="card">
      {(title || right) && (
        <header className="card-head">
          {title && <span className="card-title">{title}</span>}
          {right}
        </header>
      )}
      {children}
    </section>
  );
}

export function PageHeader({ title, sub }: { title: string; sub?: ReactNode }) {
  return (
    <header className="page-head">
      <h1>{title}</h1>
      {sub && <span className="dim">{sub}</span>}
    </header>
  );
}

export function Loading({ what }: { what: string }) {
  return <p className="dim">Loading {what}…</p>;
}

export function ErrorNote({ error }: { error: unknown }) {
  const msg = error instanceof Error ? error.message : String(error);
  return <p style={{ color: "var(--bad)" }}>⚠ {msg}</p>;
}

export function Meter({ pct, color = "var(--accent)" }: { pct: number; color?: string }) {
  const clamped = Math.max(0, Math.min(100, pct));
  return (
    <div className="meter">
      <div className="meter-fill" style={{ width: `${clamped}%`, background: color }} />
    </div>
  );
}
